import { useLang } from "hooks/useLang";
import ArtistComponent from "./artistComponent";
import { useRouter } from "next/router";

export interface IArtist {
  _id: string;
  name_en: string;
  name_ar: string;
  bio_en: string;
  bio_ar: string;
  route: any;
  photo: string; // URL string, can be empty
}

const ArtistsSection = ({
  isLoading,
  data,
  showTitle = true,
}: {
  isLoading: boolean;
  data: IArtist[]|any[];
  showTitle?:boolean
}) => {
  const { t } = useLang();
  const router = useRouter(); // Move useRouter inside component

  if (isLoading) return <></>;

  return (
    <div className={`w-full flex flex-col px-4 ${showTitle && "py-8"} layout md:max-w-[1220px]`}>
      {showTitle&&<h2 className="text-2xl font-bold mb-4 capitalize">{t("artists")}</h2>}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {data.map((item) => (
          <ArtistComponent key={item._id} {...item} route={router} />
        ))}
      </div>
    </div>
  );
};

export default ArtistsSection;
